import React from 'react'

const Files = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g>
        <path
          d='M3 19.0002V5.00024H9.59625L11.5963 7.00024H21V19.0002H3ZM4 18.0002H20V8.00024H11.1908L9.19425 6.00024H4V18.0002ZM6.5 15.5002H13.5V14.5002H6.5V15.5002ZM6.5 11.5002H17.5V10.5002H6.5V11.5002Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export default Files
